import { getOr, flow, filter } from 'lodash/fp';
import { connect } from 'react-redux';

import InstallationPricing from './InstallationPricing';
import getInstallationPricing from '../../helpers/installationPricing';

function moveChargeToFront(chargeName, arr, excludeChargesSet) {
  if (excludeChargesSet.has(chargeName)) {
    return;
  }

  let a;
  if (arr && arr.length) {
    arr.forEach((el, idx) => {
      if (arr[idx].specName === chargeName) {
        a = arr.splice(idx, 1);
        arr.unshift(a[0]);
      }
    });
  }
}

const mapStateToProps = (
  { estimateBuilder: { mandi, mandiAvailability } },
  { designId, excludeCharges },
) => {
  const { charges } = getOr({}, `designs.${designId}.pricingResult`)(mandi);

  let excludeChargesSet;
  let finalCharges = charges;
  if (excludeCharges) {
    excludeChargesSet = new Set(excludeCharges);
    finalCharges = flow(filter(({ specName }) => !excludeChargesSet.has(specName)))(charges);
  } else {
    excludeChargesSet = new Set();
  }

  moveChargeToFront('windowHaul', finalCharges, excludeChargesSet);
  moveChargeToFront('windowRemoval', finalCharges, excludeChargesSet);
  moveChargeToFront('windowAdjustment', finalCharges, excludeChargesSet);
  moveChargeToFront('windowadjustment', finalCharges, excludeChargesSet);

  const specMappings = getOr({}, 'specMappings')(mandiAvailability);

  return getInstallationPricing(finalCharges, specMappings, excludeCharges);
};

export default connect(mapStateToProps)(InstallationPricing);
